var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#5282F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H30M18 19V24M22 19V24M12 14H28L26.42 28.22C26.3658 28.7094 26.1331 29.1616 25.7663 29.49C25.3994 29.8184 24.9244 30 24.432 30H15.568C15.0756 30 14.6006 29.8184 14.2337 29.49C13.8669 29.1616 13.6342 28.7094 13.58 28.22L12 14ZM15.345 11.147C15.5068 10.804 15.7627 10.514 16.083 10.3109C16.4033 10.1078 16.7747 10 17.154 10H22.846C23.2254 9.99981 23.5971 10.1075 23.9176 10.3106C24.2381 10.5137 24.4942 10.8038 24.656 11.147L26 14H14L15.345 11.147V11.147Z",
    stroke: "#5282F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCoach);
export default __webpack_public_path__ + "static/media/deleteCoach.459c38ebe299afb4cfa4a8dc33d23e7a.svg";
export { ForwardRef as ReactComponent };